/**
 * Règles de robustesse des mots de passe (admin / comptes).
 */
export const PASSWORD_MIN_LENGTH = 8;

export function getPasswordChecks(password = '') {
  const value = String(password || '');
  return [
    {
      id: 'length',
      label: `Au moins ${PASSWORD_MIN_LENGTH} caractères`,
      ok: value.length >= PASSWORD_MIN_LENGTH,
    },
    {
      id: 'lower',
      label: 'Une lettre minuscule',
      ok: /[a-z]/.test(value),
    },
    {
      id: 'upper',
      label: 'Une lettre majuscule',
      ok: /[A-Z]/.test(value),
    },
    {
      id: 'digit',
      label: 'Un chiffre',
      ok: /\d/.test(value),
    },
    {
      id: 'special',
      label: 'Un caractère spécial (!@#$%^&*…)',
      ok: /[^A-Za-z0-9]/.test(value),
    },
  ];
}

export function validatePassword(password, confirmPassword = null) {
  if (!password) {
    return 'Veuillez saisir un mot de passe';
  }

  const failed = getPasswordChecks(password).find((check) => !check.ok);
  if (failed) {
    return `Mot de passe invalide : ${failed.label.toLowerCase()}`;
  }

  if (confirmPassword !== null && password !== confirmPassword) {
    return 'Les mots de passe ne correspondent pas';
  }

  return '';
}

export function isPasswordValid(password) {
  return getPasswordChecks(password).every((check) => check.ok);
}
